export const compareStrings = (a, b) => a < b ? -1 : (a > b ? 1 : 0)

export const formatInt = num => parseInt(num).toLocaleString('en-GB', { maximumFractionDigits: 0 })
export const formatPerc = num => (parseFloat(num) * 100).toLocaleString('en-GB', { maximumFractionDigits: 1, minimumFractionDigits: 1 }) + '%'

export const provinceMap = {
  EC: 'Eastern Cape',
  FS: 'Free State',
  GP: 'Gauteng',
  GT: 'Gauteng',
  KZN: 'KwaZulu-Natal',
  ZN: 'KwaZulu-Natal',
  LP: 'Limpopo',
  MP: 'Mpumalanga',
  NC: 'Northern Cape',
  NW: 'North West',
  WC: 'Western Cape'
}

export const formatPhone = phone => {
  if (!phone) return ''
  const phonere = /27(\d{2})(\d{3})(\d{4})/
  const match = phone.match(phonere)
  if (match) {
    return `0${match[1]} ${match[2]} ${match[3]}`
  }
}

export const formatDate = date => new Date(date).toLocaleString('en-ZA', { dateStyle: 'medium' })
